import { LoadingSpinner } from "@/core/components/loading-spinner";
import LogoIcon from "@/core/components/logo-icon";
import { Stack } from "@/core/components/ui/stack";

export const LoadingPayout = () => (
  <Stack
    align="center"
    fullWidth
    className="m-auto h-full min-h-screen max-w-md bg-card p-8"
    gap="xl"
  >
    <LogoIcon />
    <LoadingSpinner containerClassName="h-40" />
  </Stack>
);
